import slice from './userInfoSlice';

export * from './userInfoSlice';
export default slice;
